import { createContext } from 'react';

export interface IGDPRContextContext {
    show: () => void;
}

export const GDPRContext = createContext<IGDPRContextContext>({
    show: () => {},
});
